// extracted by mini-css-extract-plugin
export default {"loadercontainer":"PageLoader_loadercontainer__mJyh-","loader":"PageLoader_loader__oE2zp","animloader":"PageLoader_animloader__GCi-P"};